import TrashScheduleForm from "../features/trash-schedule/TrashScheduleForm";

const TrashScheduleView = () => {
  return <TrashScheduleForm />;
};

export default TrashScheduleView;
